export const APP_NAME = 'clickmeniu';
export const APP_DOMAIN = 'clickmeniu.com';
export const APP_URL = 'https://clickmeniu.ro';
